import { render } from "./SubcourseDetails.vue?vue&type=template&id=4267afc3&scoped=true"
import script from "./SubcourseDetails.vue?vue&type=script&lang=js"
export * from "./SubcourseDetails.vue?vue&type=script&lang=js"

import "./SubcourseDetails.vue?vue&type=style&index=0&id=4267afc3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4267afc3"]])

export default __exports__